<template>
  <CRow>
    <CCol col="12">
      <div class="container" style="margin: 80px auto" v-if="loading">
        <LoadingMDL />
      </div>

      <CDataTable
        v-else
        :header="false"
        :items="data"
        sorter
        striped
        class="customTable"
        :fields="fields"
      >
        <template #name="{item}">
          <td>
            <CRow
              alignHorizontal="start"
              alignVertical="center"
              class="ml-2"
              style="padding-right: 20px"
            >
              <h3
                :class="checkLangClass() + ' ' + 'm-0 '"
                style="font-size: 1.3rem"
              >
                {{ item.name.split('/')[0] }}
              </h3>
              <template v-if="lang === 'CN'">
                <h3 class="m-0 fontPinyin" style="font-size: 1.3rem">
                  {{ item.name.split('/')[1] }}
                </h3>
              </template>
            </CRow>
          </td>
        </template>
        <template #btnText="{item}">
          <td>
            <CRow
              alignHorizontal="around"
              :class="checkLangClass() + ' ' + 'mr-2'"
            >
              <CCol lg="6" sm="12">
                <CProgress show-value height="30px" :value="100">
                  <CProgressBar
                    class="CCProgressBar"
                    :value="getProgress(item)"
                  >
                    {{ getProgressLabel(item) }}%
                  </CProgressBar>
                </CProgress>
              </CCol>
              <CCol lg="6" sm="12">
                <CButton
                  :color="isAvailableButtonColor(item)"
                  shape="pill"
                  :variant="isAvailableButtonStyle(item)"
                  @click="isAvailableButtonRoute(item)"
                  >{{ isAvailableButtonText(item) }}</CButton
                >
              </CCol>

              <!-- {{ getProgress(item) }}% -->
            </CRow>
          </td>
        </template>
      </CDataTable>
    </CCol>
  </CRow>
</template>
<script>
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseStyle.scss';
import '../../../../assets/scss/_chineseIcon.scss';
import LoadingMDL from '../../../../components/loading/LoadingMDL.vue';

export default {
  name: 'ChapterTable',
  props: {
    allItem: Array,
    chapterProgress: Array,
    chapterList: Array,
    loading: Boolean,
    showProgressLabel: Function,
  },
  components: {
    LoadingMDL,
  },
  data() {
    return {
      lang: '',
      progress: [],
      data: [],
      lessonId: this.$route.params.id,
      topic: [],
      pinyin: [],
      fields: [
        'name',
        // {key: 'name'},
        {key: 'btnText'},
      ],
      button: {
        color: '',
        variant: '',
        route: '',
      },
      code: this.$route.params.id,
      allTopic: [],
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
    }),
  },
  watch: {
    pinyin: function (val) {},
    storeLanguage: function (val) {
      this.lang = val;
      this.setNewData();
    },
    chapterProgress: function (val) {
      if (!val) return;

      console.log(val, 'topics progress');

      this.progress = val;
      this.allTopic = val;
    },
  },
  created() {
    this.lang = this.$store.state.language.language;
    this.setNewData();
  },
  mounted() {
    // console.log(this.data);
    // console.log(this.progress);
  },
  methods: {
    getProgress(item) {
      const allItems = this.allItem; //arr

      const progressList = Array.isArray(this.progress) ? this.progress : [];

      const mapped = allItems.map((chapterItem) => {
        const matchedProgress = progressList.find((p) => {
          const chapterNum = parseInt(p.codeItem.split('-')[2], 10);
          return chapterNum === chapterItem.chapter;
        });

        return {
          ...chapterItem,
          progress: matchedProgress?.progress ?? 0,
        };
      });

      const match = mapped.find((i) => i.button.action === item.action);

      const num = Math.trunc(match.progress);

      if (num !== null) {
        if (num <= 30 && num > 0) {
          return 20;
        } else if (num == 0) {
          return 10;
        } else {
          return num;
        }
      }
    },
    getProgressLabel(item) {
      const allItems = this.allItem; //arr

      const progressList = Array.isArray(this.progress) ? this.progress : [];

      const mapped = allItems.map((chapterItem) => {
        const matchedProgress = progressList.find((p) => {
          const chapterNum = parseInt(p.codeItem.split('-')[2], 10);
          return chapterNum === chapterItem.chapter;
        });

        return {
          ...chapterItem,
          progress: matchedProgress?.progress ?? 0,
        };
      });

      const match = mapped.find((i) => i.button.action === item.action);

      return match ? Math.trunc(match.progress).toString() : '0';
    },
    checktext(name) {
      return name;
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkPinyin(val) {
      if (val) {
        for (var i = 0; i <= val.length; i++) {
          if (val[i].key == 'PIN IN') {
            var pin = val[i].value.split('：');
            return '(' + pin[1] + ')';
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    test(testerParameters) {
      alert(JSON.stringify(testerParameters));
    },
    setNewData() {
      this.data = [];
      if (this.allItem) {
        for (var i = 0; i <= this.allItem.length; i++) {
          var item = this.allItem[i];
          if (item) {
            var name = '';
            if (this.lang === 'CN') {
              var pinin = this.checkPinyin(item.title);
              var chn = this.$helpers.translate(item.title, this.lang);
              name = chn + ' ' + '/' + pinin;
            } else {
              name = this.$helpers.translate(item.title, this.lang);
            }
            var btn_url = item.button.action;
            var btn_text = this.$helpers.translate(item.button.text, this.lang);

            this.data.push({
              name: name,
              action: btn_url,
              btnText: btn_text,
              id: i,
            });
          }
        }
      }
    },
    linkTo(data) {},
    isAvailableButtonColor(data) {
      //check if data is avaliable ?
      if (this.allTopic.length === 0) {
        return 'success';
      }
      //if have using old logic
      const locked = this.allTopic[data.id]?.lock;
      if (locked) {
        return 'danger';
      } else {
        return 'success';
      }
    },
    isAvailableButtonStyle(data) {
      //check if data is avaliable ?
      if (this.allTopic.length === 0) {
        return '';
      }
      const locked = this.allTopic[data.id]?.lock;
      if (locked) {
        return 'outline';
      } else {
        return '';
      }
    },
    isAvailableButtonText(data) {
      //check if data is avaliable ?
      if (this.allTopic.length === 0) {
        return 'Start';
      }
      const locked = this.allTopic[data.id]?.lock;
      if (locked) {
        return 'Locked';
      } else {
        return 'Start';
      }
    },
    isAvailableButtonRoute(data) {
      let locked = this.allTopic[data.id]?.lock;
      const nextAction = data.action;
      const pathFormat = nextAction.split('-');

      if (data.id == 0) {
        //navigate
        // let str = data.action.split('-');
        // let body = '/' + str[0] + '/' + str[1];
        // this.$store.commit('necessary/setCodePage', str[1]);

        this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

        //setOn is learn
        this.$store.commit('v3/v3IsLearnOn');
        //stamp main code item
        this.$store.commit('v3/stampMainCodeItem', nextAction); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล

        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      } else {
        if (locked) {
          //if locked
          return;
        } else {
          this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage

          //setOn is learn
          this.$store.commit('v3/v3IsLearnOn');
          //stamp main code item
          this.$store.commit('v3/stampMainCodeItem', nextAction); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล

          //navigate
          // let str = data.action.split('-');
          // let body = '/' + str[0] + '/' + str[1];
          // this.$store.commit('necessary/setCodePage', str[1]);
          this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
        }
      }
    },
  },
};
</script>
<style scoped>
.customTable {
  border: none !important;
}
.progress {
  background-color: #99adc1;
}
.CCProgressBar {
  background-color: #4c7093;
}
</style>
